import { LocaleTranslationKeysEnum } from '@src/core/i18n/locale-translation-keys.enum';
import { useCallback } from 'react';
import { ErrorPageTemplate } from 'swo-ciam-common-react';
import image from '../../../../../../public/images/no_email.png';
import { RoutePathsEnum } from '../../../route-paths.enum';

const VerifyEmailErrorComponent = () => {
  const buttonClickHandler = useCallback(() => {
    window.location.href = '/';
  }, []);

  return (
    <ErrorPageTemplate
      items={[
        { key: LocaleTranslationKeysEnum.AuthVerifyEmailErrorTitle },
        {
          key: LocaleTranslationKeysEnum.AuthVerifyEmailErrorSubTitle,
        },
        {
          key: LocaleTranslationKeysEnum.AuthVerifyEmailErrorHelpText,
        },
      ]}
      link={{ external: false, url: RoutePathsEnum.Home }}
      image={{ src: image, alt: LocaleTranslationKeysEnum.SwoErrorPages500ImgAlt }}
      button={{
        label: LocaleTranslationKeysEnum.SwoErrorPagesSharedActionsGoBack,
        placeholder: LocaleTranslationKeysEnum.SwoErrorPagesSharedActionsGoBack,
        onClick: buttonClickHandler,
      }}
      footerText={{
        key: LocaleTranslationKeysEnum.SwoErrorPagesSharedFooterText,
      }}
    />
  );
};

export default VerifyEmailErrorComponent;
